$('.js-navword-click a').on('click', function(){
  $('.js-navword-click a').parent().removeClass('is_active');
  $(this).parent().addClass('is_active');
  var cat = $(this).attr("class");
  var keyword = $(this).find('.programSec01__catList__txt').text();
  $('.js-navword-keyword').text(keyword);
  $('.js-navlist li').addClass('is_disable');
  $('.js-navlist li').each(function(index) {
    if($(this).hasClass(cat)) {
      $(this).removeClass('is_disable');
    }
  });
  if($('.js-navlist li').hasClass(cat)) {
    $(this).removeClass('is_disable');
  }
  var headerHeight = $('.header').outerHeight(true);
  var position = $('#programSec02').offset().top - headerHeight;
  $('body,html').stop().animate({scrollTop: position}, 500);
});

$('.js-navword-reset').on('click', function(){
  $('.js-navword-click a').parent().removeClass('is_active');
  $('.js-navlist li').removeClass('is_disable');
  $('.js-navword-keyword').text('すべてのプログラム');
});
